import { DmMessageCountInterface } from '@platri/df-common-chat-plug-play';

export class DmMessageCountDto implements DmMessageCountInterface{
  danceManagerId: string;
  count: number;
}
